const divModalDocEmployee = {
  uploadSubmitError: 'Wait for all files to upload',
  uploadEmptyFileError: 'Minimum 1 file required'
};

export default divModalDocEmployee;
